import script from "./FreelanceDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./FreelanceDashboard.vue?vue&type=script&setup=true&lang=js"

import "./FreelanceDashboard.vue?vue&type=style&index=0&id=77595100&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77595100"]])

export default __exports__